import { BreakpointDefinition } from "utils/Breakpoint";
import { createSelector } from "reselect";

import getBreakpoint from "./getBreakpoint";

const getShowSlideshowGalleryImages = createSelector(
  [getBreakpoint],
  (breakpoint) => breakpoint.isGreaterThan(BreakpointDefinition.XS),
);

export default getShowSlideshowGalleryImages;
